import { useEffect, ReactNode } from 'react';
import { usePageTitleContext } from 'shared/contexts/PageTitleContext';

export const usePageTitle = (title?: string | null, description?: string, extra?: ReactNode) => {
  const { setPageTitle, setTitleExtra } = usePageTitleContext();

  useEffect(() => {
    // Skip if no title provided (e.g. embedded components that shouldn't override parent title)
    if (!title) return;

    // Update document title immediately
    document.title = title;

    // Update layout header title
    setPageTitle(title);

    // Update extra element (e.g. status chip)
    setTitleExtra(extra || null);

    // Update meta description if provided
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);
    }

    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = 'Safety';
      setPageTitle('');
      setTitleExtra(null);
    };
  }, [title, description, extra, setPageTitle, setTitleExtra]);
};

// Helper function to get consistent page titles
export const getPageTitle = (pageName: string): string => {
  return `${pageName}`;
};
